(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jdc-character-hero"] && !Shopify.designMode) return;
  try {
    
  const setupCharacterNavigation = (navigationShell) => {
    if (navigationShell.dataset.jdcNavigationReady === 'true') return;
    const navigation = navigationShell.querySelector('.jdc-character-hero-section__nav');
    const scrollbar = navigationShell.querySelector('.jdc-character-hero-section__scrollbar');
    const scrollbarThumb = scrollbar.querySelector('span');
    const updateNavigation = () => {
      const scrollRange = navigation.scrollWidth - navigation.clientWidth;
      const isScrollable = scrollRange > 1;
      navigationShell.classList.toggle('is-scrollable', isScrollable);
      if (!isScrollable) return;
      const scrollbarWidth = scrollbar.clientWidth;
      const thumbWidth = Math.max(42, scrollbarWidth * navigation.clientWidth / navigation.scrollWidth);
      const thumbRange = scrollbarWidth - thumbWidth;
      const thumbOffset = thumbRange * navigation.scrollLeft / scrollRange;
      scrollbarThumb.style.setProperty('--jdc-scrollbar-thumb-width', `${thumbWidth}px`);
      scrollbarThumb.style.setProperty('--jdc-scrollbar-thumb-offset', `${thumbOffset}px`);
    };
    navigationShell.dataset.jdcNavigationReady = 'true';
    navigation.addEventListener('scroll', updateNavigation, { passive: true });
    requestAnimationFrame(updateNavigation);
    new ResizeObserver(updateNavigation).observe(navigation);
  };

  const setupCharacterNavigations = () => {
    document.querySelectorAll('.jdc-character-hero-section__nav-shell').forEach(setupCharacterNavigation);
  };

  setupCharacterNavigations();
  document.addEventListener('shopify:section:load', setupCharacterNavigations);

  } catch(e) { console.error(e); }
})();
})();
